import { useContext } from "react";
import { TellescopeTanstackDefaultsConfig } from "../types";
import { TellescopeTanstackConfigContext } from "./context";

type ExhaustiveTellescopeTanstackDefaultsConfig = {
  [K in keyof Required<TellescopeTanstackDefaultsConfig>]: Required<TellescopeTanstackDefaultsConfig>[K] | undefined;
};

export const useTellescopeTanstackConfigContext = (
  config?: TellescopeTanstackDefaultsConfig
): TellescopeTanstackDefaultsConfig => {
  const contextConfig = useContext(TellescopeTanstackConfigContext);

  const exhaustiveCombinedConfig: ExhaustiveTellescopeTanstackDefaultsConfig = {
    autoCacheUpdateStrategy: config?.autoCacheUpdateStrategy ?? contextConfig?.autoCacheUpdateStrategy,
    optimisticUpdates: config?.optimisticUpdates ?? contextConfig?.optimisticUpdates,
    crossQueryCacheSharing: config?.crossQueryCacheSharing ?? contextConfig?.crossQueryCacheSharing,
    minSearchScore: config?.minSearchScore ?? contextConfig?.minSearchScore,
  };

  return exhaustiveCombinedConfig;
};
